export const enum SocialIconsDataHooks {
  socialIconsTitle = 'social-icons-title',
  socialIconsUrl = 'social-icons-url-',
}
